import React from 'react'

import { CURRENCIES } from '../../constants'
import { useTranslation } from '../../contexts/I18nContext'
import RecipeAccordionSection from '../RecipeAccordionSection'
import PricePerPortionBadge from '../PricePerPortionBadge'

import Styled from './RecipePricePerPortion.styled'

const RecipePricePerPortion = ({
  id,
  className,
  recipePricePerPortionLevels,
  pricePerPortionTag,
}) => {
  const { t } = useTranslation()

  return (
    <RecipeAccordionSection
      id={id}
      className={className}
      title={t('RECIPE.PRICE_PER_PORTION')}
      variant="powder"
      headerRight={
        <PricePerPortionBadge
          level={pricePerPortionTag.level}
          currency={pricePerPortionTag.currency}
          label={pricePerPortionTag.label}
          isFull
        />
      }
    >
      <Styled>
        <Styled.tagsTable>
          <Styled.tags>
            {recipePricePerPortionLevels.map((tag) => (
              <Styled.tag
                key={tag.level}
                $isActive={tag.level === pricePerPortionTag.level}
              >
                <Styled.tagUnit>
                  {(CURRENCIES?.[tag?.currency]?.symbol || '').repeat(
                    tag.level,
                  )}
                </Styled.tagUnit>
                <Styled.tagLabel>{tag.label}</Styled.tagLabel>
              </Styled.tag>
            ))}
          </Styled.tags>
        </Styled.tagsTable>
        <Styled.footnote>{t('RECIPE.PRICE_PER_PORTION_NOTE')}</Styled.footnote>
      </Styled>
    </RecipeAccordionSection>
  )
}

export default RecipePricePerPortion
